






















import { Component, Ref, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MixinErrorBox from './index';

@Component({
	name: 'ErrorBox'
})
/** ErrorBox */
export default class ErrorBox extends mixins(MixinErrorBox) {}
